module.exports = new __parcel__URL__("background.66b3a48c.png").toString();